import {
	Breakpoints,
	BreakpointWrapper,
	Container,
	ContainerPadding,
	CTA,
	FocusLayer,
	LayerWrapper,
	Layout,
	Richtext,
	ShimLayer,
	styled,
	Text,
	TextAlignment,
} from '@volkswagen-onehub/components-core';
import * as Icons from '@volkswagen-onehub/icons-core';
import { Close } from '@volkswagen-onehub/icons-core';
import React from 'react';
import { Promocion } from '../../services/ofertas-service/models/ofertas';

export const FixedDiv = styled.div`
	position: fixed;
	bottom: 24px;
	left: 50%;
	transform: translateX(-50%);
	background: #ffffff;
	border-radius: 15px;
	z-index: 2;
`;

const formatPromotionText = (promotionText: string) => {
	const formatedPromotionText = promotionText.replace(/\n/g, '\n<br>\n');

	return formatedPromotionText;
};

export function renderLayerWrapper(handleLayerOnClick: () => void, selectedPromotion: Promocion) {
	return (
		<LayerWrapper contentCentered>
			<>
				<ShimLayer />
				<FocusLayer active size="B" aria-label="promotion-layer">
					<Container
						verticalAlign={'flex-end'}
						horizontalAlign={'flex-end'}
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0100,
								[Breakpoints.b1600]: ContainerPadding.dynamic0100,
							},
							right: ContainerPadding.dynamic0100,
						}}
						stretchContent
					>
						<Text textAlign={TextAlignment.end}>
							<CTA
								tag="button"
								emphasis="secondary"
								size="small"
								onClick={handleLayerOnClick}
								icon={<Icons.Close variant="small" />}
							/>
						</Text>
					</Container>
					<Container
						wrap="always"
						padding={{
							top: ContainerPadding.static200,
							bottom: {
								[Breakpoints.default]: ContainerPadding.static500,
								[Breakpoints.b560]: ContainerPadding.static200,
							},
						}}
					>
						<Layout
							data-testid="ofertas__layout-label"
							appearance={{
								[Breakpoints.default]: [
									{ name: '.', columns: 2 },
									{ name: 'a', columns: 20 },
									{ name: '.', columns: 2 },
								],
								[Breakpoints.b560]: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 22 },
									{ name: '.', columns: 1 },
								],
								[Breakpoints.b960]: [
									{ name: '.', columns: 2 },
									{ name: 'a', columns: 20 },
									{ name: '.', columns: 2 },
								],
							}}
						>
							<Richtext markdown={formatPromotionText(selectedPromotion?.descripcion)} dangerouslyParseRawHTML />
							<Container
								padding={{
									top: ContainerPadding.static400,
									bottom: ContainerPadding.dynamic0100,
								}}
								verticalAlign={'center'}
								stretchContent
							>
								{selectedPromotion.cta.url && (
									<CTA tag="a" emphasis="secondary" href={selectedPromotion.cta.url}>
										{selectedPromotion.cta.label}
									</CTA>
								)}
							</Container>
						</Layout>
					</Container>
				</FocusLayer>

				<BreakpointWrapper min={Breakpoints.default} max={Breakpoints.b560}>
					<FixedDiv className="ofertas__fixed-div">
						<CTA
							tag="button"
							emphasis="secondary"
							size="small"
							onClick={handleLayerOnClick}
							icon={<Close variant="small" />}
						>
							Cerrar
						</CTA>
					</FixedDiv>
				</BreakpointWrapper>
			</>
		</LayerWrapper>
	);
}
